import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { catchError, concatMap, map, switchMap } from 'rxjs/operators'

import { dynamicContentItemActions } from './dynamic-content-item.actions'
import { DynamicContentItemService } from './dynamic-content-item.service'

@Injectable()
export class DynamicContentItemEffects {
  constructor(
    private actions$: Actions,
    private dynamicContentItemService: DynamicContentItemService
  ) {}

  fetchByTagId = createEffect(() =>
    this.actions$.pipe(
      ofType(dynamicContentItemActions.fetchByTagId),
      switchMap((action) =>
        this.dynamicContentItemService.getSections(action.tagId).pipe(
          map(({ entities, revision }) =>
            dynamicContentItemActions.replaceByTag({
              tagId: action.tagId,
              entities,
              revision
            })
          ),
          catchError((error) => {
            console.error(
              'Error fetching dynamic content sections by tag ID:',
              error
            )
            return of(
              dynamicContentItemActions.fetchByTagIdFailed({
                tagId: action.tagId
              })
            )
          })
        )
      )
    )
  )

  saveSections = createEffect(() =>
    this.actions$.pipe(
      ofType(dynamicContentItemActions.saveSections),
      concatMap((action) =>
        this.dynamicContentItemService
          .replaceSections(
            action.tagId,
            action.sections,
            action.expectedRevision
          )
          .pipe(
            map(({ entities, revision }) =>
              dynamicContentItemActions.saveSectionsSuccess({
                tagId: action.tagId,
                entities,
                revision,
                requestKey: action.requestKey
              })
            ),
            catchError((error) => {
              console.error('Error saving dynamic content sections:', error)
              const conflict = error?.status === 409

              return this.dynamicContentItemService
                .getSections(action.tagId)
                .pipe(
                  concatMap(({ entities, revision }) => [
                    dynamicContentItemActions.replaceByTag({
                      tagId: action.tagId,
                      entities,
                      revision
                    }),
                    dynamicContentItemActions.saveSectionsFailed({
                      tagId: action.tagId,
                      requestKey: action.requestKey,
                      conflict
                    })
                  ]),
                  catchError((recoveryError) => {
                    console.error(
                      'Error reloading dynamic content sections after save failure:',
                      recoveryError
                    )
                    return of(
                      dynamicContentItemActions.saveSectionsFailed({
                        tagId: action.tagId,
                        requestKey: action.requestKey,
                        conflict
                      })
                    )
                  })
                )
            })
          )
      )
    )
  )
}
